/* Infinite scroll for collection + search product grids (15 Oct 2026).
   Server renders normal pagination links (no-JS fallback). This script hides them, then when the
   sentinel nears the viewport fetches the next page's section HTML (same sort/filter params, as the
   next URL comes from Liquid's paginate.next.url), appends the .product-item cards and moves to the following page.
   Filter/sort changes re-render .collection__dynamic-part via theme.js; a MutationObserver re-initialises. */
(function () {
  if (window.__hkInfiniteScroll) return; window.__hkInfiniteScroll = true;
  var gen = 0;

  function sectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    if (sectionId) u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function setup(section) {
    var pag = section.querySelector('.pagination[data-infinite-scroll]');
    var grid = section.querySelector('.product-list--collection');
    if (!pag || !grid || pag.__hkIs) return;
    pag.__hkIs = true;
    var myGen = ++gen; section.__hkIsGen = myGen;
    var next = pag.getAttribute('data-next-url');
    if (!next) return; // single page or last page: nothing to do
    var sectionId = section.getAttribute('data-section-id');
    var countEl = section.querySelector('.collection__showing-count');

    var ui = document.createElement('div');
    ui.className = 'hk-is';
    ui.innerHTML = '<div class="hk-is__spinner" role="status" aria-label="Loading more products"></div>' +
      '<button type="button" class="hk-is__more button button--secondary">Load more</button>';
    pag.parentNode.insertBefore(ui, pag.nextSibling);
    document.documentElement.classList.add('hk-is-ready');
    var btn = ui.querySelector('.hk-is__more');
    var loading = false, io = null;

    function done() { if (io) io.disconnect(); ui.remove(); }

    function load() {
      if (loading || !next || section.__hkIsGen !== myGen) return;
      loading = true; ui.classList.add('is-loading');
      fetch(sectionUrl(next, sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (section.__hkIsGen !== myGen || !grid.isConnected) return; // filters/sort changed meanwhile
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var newGrid = tmp.querySelector('.product-list--collection');
          var frag = document.createDocumentFragment();
          if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { frag.appendChild(c); });
          grid.appendChild(frag);
          var np = tmp.querySelector('.pagination[data-infinite-scroll]');
          next = np ? np.getAttribute('data-next-url') : '';
          // keep no-JS links in sync with how far we've loaded
          if (np) pag.innerHTML = np.innerHTML; pag.setAttribute('data-next-url', next || '');
          var nc = tmp.querySelector('.collection__showing-count');
          if (countEl && nc) {
            var a = countEl.textContent.match(/(\d[\d,]*)\s*[-–]\s*(\d[\d,]*)/), b = nc.textContent.match(/(\d[\d,]*)\s*[-–]\s*(\d[\d,]*)/);
            if (a && b) countEl.textContent = countEl.textContent.replace(a[0], a[1] + ' - ' + b[2]);
          }
          window.dispatchEvent(new Event('resize')); // theme recalculates card swatches on resize
          document.dispatchEvent(new CustomEvent('hk:products-appended', { detail: { section: section } }));
          loading = false; ui.classList.remove('is-loading');
          if (!next) done(); else if (io) { io.unobserve(ui); io.observe(ui); }
        })
        .catch(function () {
          loading = false; ui.classList.remove('is-loading');
          if (io) io.disconnect(); io = null; btn.hidden = false; // fall back to manual button
        });
    }

    btn.addEventListener('click', load);
    if ('IntersectionObserver' in window) {
      btn.hidden = true;
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) load(); }); }, { rootMargin: '0px 0px 800px 0px' });
      io.observe(ui);
    }
  }

  function scan() { document.querySelectorAll('[data-section-type="collection"]').forEach(setup); }
  function init() {
    scan();
    // theme.js swaps .collection__dynamic-part innerHTML on filter/sort/layout change -> new pagination node -> re-setup
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { scan(); break; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
